// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {

    /**
     * colors
     */
  
    /* gradient */
  
    --bg-gradient-onyx: linear-gradient(
      to bottom right, 
      hsl(240, 1%, 25%) 3%, 
      hsl(0, 0%, 19%) 97%
    );
    --bg-gradient-jet: linear-gradient(
      to bottom right, 
      hsla(240, 1%, 18%, 0.251) 0%, 
      hsla(240, 2%, 11%, 0) 100%
    ), hsl(240, 2%, 13%);
    --bg-gradient-yellow-1: linear-gradient(
      to bottom right, 
      hsl(45, 100%, 71%) 0%, 
      hsla(36, 100%, 69%, 0) 50%
    );
    --bg-gradient-yellow-2: linear-gradient(
      135deg, 
      hsla(45, 100%, 71%, 0.251) 0%, 
      hsla(35, 100%, 68%, 0) 59.86%
    ), hsl(240, 2%, 13%);
    --border-gradient-onyx: linear-gradient(
      to bottom right, 
      hsl(0, 0%, 25%) 0%, 
      hsla(0, 0%, 25%, 0) 50%
    );
    --text-gradient-yellow: linear-gradient(
      to right, 
      hsl(45, 100%, 72%), 
      hsl(35, 100%, 68%)
    );
  
    /* solid */
  
    --jet: hsl(0, 0%, 22%);
    --onyx: hsl(240, 1%, 17%);
    --eerie-black-1: hsl(240, 2%, 13%);
    --eerie-black-2: hsl(240, 2%, 12%);
    --smoky-black: hsl(0, 0%, 7%);
    --white-1: hsl(0, 0%, 100%);
    --white-2: hsl(0, 0%, 98%);
    --orange-yellow-crayola: hsl(45, 100%, 72%);
    --vegas-gold: hsl(45, 54%, 58%);
    --light-gray: hsl(0, 0%, 84%);
    --light-gray-70: hsla(0, 0%, 84%, 0.7);
    --bittersweet-shimmer: hsl(0, 43%, 51%);
  
    /**
     * typography
     */
  
    /* font-family */
    --ff-poppins: 'Poppins', sans-serif;
  
    /* font-size */
    --fs-1: 24px;
    --fs-2: 18px;
    --fs-3: 17px;
    --fs-4: 16px;
    --fs-5: 15px;
    --fs-6: 14px;
    --fs-7: 13px;
    --fs-8: 11px;
  
    /* font-weight */
    --fw-300: 300;
    --fw-400: 400;
    --fw-500: 500;
    --fw-600: 600;
  
    /**
     * shadow
     */
    
    --shadow-1: -4px 8px 24px hsla(0, 0%, 0%, 0.25);
    --shadow-2: 0 16px 30px hsla(0, 0%, 0%, 0.25);
    --shadow-3: 0 16px 40px hsla(0, 0%, 0%, 0.25);
    --shadow-4: 0 25px 50px hsla(0, 0%, 0%, 0.15);
    --shadow-5: 0 24px 80px hsla(0, 0%, 0%, 0.25);
  
    /**
     * transition
     */
  
    --transition-1: 0.25s ease;
    --transition-2: 0.5s ease-in-out;
  
  }`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;;IAEI;;MAEE;;IAEF,aAAa;;IAEb;;;;KAIC;IACD;;;;wBAIoB;IACpB;;;;KAIC;IACD;;;;wBAIoB;IACpB;;;;KAIC;IACD;;;;KAIC;;IAED,UAAU;;IAEV,sBAAsB;IACtB,yBAAyB;IACzB,kCAAkC;IAClC,kCAAkC;IAClC,6BAA6B;IAC7B,2BAA2B;IAC3B,0BAA0B;IAC1B,2CAA2C;IAC3C,+BAA+B;IAC/B,6BAA6B;IAC7B,sCAAsC;IACtC,uCAAuC;;IAEvC;;MAEE;;IAEF,gBAAgB;IAChB,mCAAmC;;IAEnC,cAAc;IACd,YAAY;IACZ,YAAY;IACZ,YAAY;IACZ,YAAY;IACZ,YAAY;IACZ,YAAY;IACZ,YAAY;IACZ,YAAY;;IAEZ,gBAAgB;IAChB,aAAa;IACb,aAAa;IACb,aAAa;IACb,aAAa;;IAEb;;MAEE;;IAEF,+CAA+C;IAC/C,6CAA6C;IAC7C,6CAA6C;IAC7C,6CAA6C;IAC7C,6CAA6C;;IAE7C;;MAEE;;IAEF,0BAA0B;IAC1B,gCAAgC;;EAElC","sourcesContent":[":root {\n\n    /**\n     * colors\n     */\n  \n    /* gradient */\n  \n    --bg-gradient-onyx: linear-gradient(\n      to bottom right, \n      hsl(240, 1%, 25%) 3%, \n      hsl(0, 0%, 19%) 97%\n    );\n    --bg-gradient-jet: linear-gradient(\n      to bottom right, \n      hsla(240, 1%, 18%, 0.251) 0%, \n      hsla(240, 2%, 11%, 0) 100%\n    ), hsl(240, 2%, 13%);\n    --bg-gradient-yellow-1: linear-gradient(\n      to bottom right, \n      hsl(45, 100%, 71%) 0%, \n      hsla(36, 100%, 69%, 0) 50%\n    );\n    --bg-gradient-yellow-2: linear-gradient(\n      135deg, \n      hsla(45, 100%, 71%, 0.251) 0%, \n      hsla(35, 100%, 68%, 0) 59.86%\n    ), hsl(240, 2%, 13%);\n    --border-gradient-onyx: linear-gradient(\n      to bottom right, \n      hsl(0, 0%, 25%) 0%, \n      hsla(0, 0%, 25%, 0) 50%\n    );\n    --text-gradient-yellow: linear-gradient(\n      to right, \n      hsl(45, 100%, 72%), \n      hsl(35, 100%, 68%)\n    );\n  \n    /* solid */\n  \n    --jet: hsl(0, 0%, 22%);\n    --onyx: hsl(240, 1%, 17%);\n    --eerie-black-1: hsl(240, 2%, 13%);\n    --eerie-black-2: hsl(240, 2%, 12%);\n    --smoky-black: hsl(0, 0%, 7%);\n    --white-1: hsl(0, 0%, 100%);\n    --white-2: hsl(0, 0%, 98%);\n    --orange-yellow-crayola: hsl(45, 100%, 72%);\n    --vegas-gold: hsl(45, 54%, 58%);\n    --light-gray: hsl(0, 0%, 84%);\n    --light-gray-70: hsla(0, 0%, 84%, 0.7);\n    --bittersweet-shimmer: hsl(0, 43%, 51%);\n  \n    /**\n     * typography\n     */\n  \n    /* font-family */\n    --ff-poppins: 'Poppins', sans-serif;\n  \n    /* font-size */\n    --fs-1: 24px;\n    --fs-2: 18px;\n    --fs-3: 17px;\n    --fs-4: 16px;\n    --fs-5: 15px;\n    --fs-6: 14px;\n    --fs-7: 13px;\n    --fs-8: 11px;\n  \n    /* font-weight */\n    --fw-300: 300;\n    --fw-400: 400;\n    --fw-500: 500;\n    --fw-600: 600;\n  \n    /**\n     * shadow\n     */\n    \n    --shadow-1: -4px 8px 24px hsla(0, 0%, 0%, 0.25);\n    --shadow-2: 0 16px 30px hsla(0, 0%, 0%, 0.25);\n    --shadow-3: 0 16px 40px hsla(0, 0%, 0%, 0.25);\n    --shadow-4: 0 25px 50px hsla(0, 0%, 0%, 0.15);\n    --shadow-5: 0 24px 80px hsla(0, 0%, 0%, 0.25);\n  \n    /**\n     * transition\n     */\n  \n    --transition-1: 0.25s ease;\n    --transition-2: 0.5s ease-in-out;\n  \n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
